export interface FxPresetEffect {
  type: string;
  params?: Record<string, number>;
}

export interface FxPreset {
  name: string;
  effects: FxPresetEffect[];
}

/**
 * Built-in FX chain presets. Applying one replaces the target channel's
 * insert chain with these slots (param overrides merged over defaults).
 */
export const FX_PRESETS: FxPreset[] = [
  {
    name: 'Plate Verb',
    effects: [{ type: 'reverb', params: { decay: 2.2, preDelay: 0.02, wet: 0.35 } }],
  },
  {
    name: 'Dub Delay',
    effects: [{ type: 'delay', params: { time: 375, feedback: 0.6, wet: 0.45 } }],
  },
  {
    name: 'Lo-Fi Crush',
    effects: [
      { type: 'bitcrusher', params: { sampleRate: 30, bits: 8, wet: 0.6 } },
      { type: 'eq', params: { highGain: -8, lowGain: 2 } },
    ],
  },
  {
    name: 'Choir',
    effects: [
      { type: 'chorus', params: { rate: 0.8, depth: 0.7, wet: 0.5 } },
      { type: 'reverb', params: { decay: 3, wet: 0.25 } },
    ],
  },
  {
    name: 'Drive Plate',
    effects: [
      { type: 'distortion', params: { drive: 18, wet: 0.5 } },
      { type: 'reverb', params: { decay: 2.5, wet: 0.3 } },
    ],
  },
  {
    name: 'Flanger Machine',
    effects: [{ type: 'flanger', params: { rate: 0.5, depth: 0.8, feedback: 0.5, wet: 0.4 } }],
  },
];